import { render } from "./ClientTabs.vue?vue&type=template&id=4f34d65a&scoped=true"
import script from "./ClientTabs.vue?vue&type=script&lang=js"
export * from "./ClientTabs.vue?vue&type=script&lang=js"

import "./ClientTabs.vue?vue&type=style&index=0&id=4f34d65a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f34d65a"]])

export default __exports__